// extracted by mini-css-extract-plugin
export default {"whoWeAre":"WhoWeAre_whoWeAre__B1D0T"};